// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"global-filter_searchBar__1qdmC","searchIcon":"global-filter_searchIcon__2NT6P"};